import React, { useState } from "react";
import NavMobile from "../Nav/NavMobile";
import NavWeb from "../Nav/NavWeb";
import { Button } from "../../ui/button";
import "./DashBoard.css";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../ui/table";
import { useLocation } from "react-router-dom";
import Calendar from "../../../Components/Administrativo/EstudiantesPrivados/Dashboard/Calendar";
import { BellIcon } from "@radix-ui/react-icons";
import Loader from "../../Loader/Loader";
import ParticipantInfoDialog from "../RegistrarHoras/ParticipantInfoDialog";
import AdditionalPaymentsDialog from "./AdditionalPaymentsDialog";
import { infoDashboardTeacher } from "../../../provider/profesor/infoDashboardTeacher";
import { getClassesByTeacherAndDateTimeBetweenDays } from "../../../provider/profesor/ListClasess/getClassesByTeacherAndDateTimeBetweenDays";
import { Toaster } from "sonner";
import { PlusSquare, ExternalLink } from "lucide-react";

const DashBoardProfesor = () => {
  const [date, setDate] = useState({
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear().toString(),
  });
  const [classes_participante, setclasses_participante] = useState([]);
  const [info, setInfo] = useState({});
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const teacherId = params.get("profesorId");
  const nombre = params.get("nombre");
  const [loading, setLoading] = useState(false);
  
  // Add state for participant info dialog
  const [participantInfoDialog, setParticipantInfoDialog] = useState({
    isOpen: false,
    participantId: null,
    participantType: null,
  });

  // Add state for additional payments dialog
  const [additionalPaymentsDialog, setAdditionalPaymentsDialog] = useState(false);

  // Estados para los filtros
  const [filters, setFilters] = useState({
    idClase: '',
    fecha: '',
    participanteId: ''
  });

  // Función para manejar cambios en los filtros
  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };
  const showParticipantInfo = (participantId, participantType) => {
    setParticipantInfoDialog({
      isOpen: true,
      participantId,
      participantType,
    });
  };

  // Función para limpiar filtros
  const clearFilters = () => {
    setFilters({
      idClase: '',
      fecha: '',
      participanteId: ''
    });
  };

  // Función para filtrar las clases
  const filteredClasses = classes_participante.filter(classData => {
    const matchesId = !filters.idClase || 
      classData.id.toString().toLowerCase().includes(filters.idClase.toLowerCase());
    
    const matchesFecha = !filters.fecha || 
      new Date(classData.dateTime).getDate().toString() === filters.fecha;
    
    const matchesParticipante = !filters.participanteId || 
      classData.participantID.toString().toLowerCase().includes(filters.participanteId.toLowerCase());

    return matchesId && matchesFecha && matchesParticipante;
  });

  // Render the loading state separately
  if (loading) {
    return <Loader />;
  }

  return (
    <div
      className="min-h-screen flex"
      style={{ overflowY: "hidden", height: "100vh" }}
    >
      <NavMobile />
      <NavWeb />
      <div className="dashboardprofesorview">
        <div className="dashboardcontainergroup">
          {/* Add the ParticipantInfoDialog component */}
          <ParticipantInfoDialog
            isOpen={participantInfoDialog.isOpen}
            onClose={() => setParticipantInfoDialog({ isOpen: false })}
            participantId={participantInfoDialog.participantId}
            participantType={participantInfoDialog.participantType}
          />

          {/* Add the AdditionalPaymentsDialog component */}
          <AdditionalPaymentsDialog
            isOpen={additionalPaymentsDialog}
            onClose={() => setAdditionalPaymentsDialog(false)}
            teacherId={teacherId}
            date={date}
          />

          <div className="tituloynotificaciones">
            <h2 className="text-xl font-bold text-gray-900">
              Teacher {nombre} with ID {teacherId}
            </h2>
            <BellIcon className="h-6 w-6" />
          </div>
          <div className="filtrosandbackbtn">
            <div className="actions">
              <Calendar
                setDate={(date) => setDate(date)}
                date={date}
                ID={teacherId}
                setClasses={setclasses_participante}
                getClassesWithFirstandEndDate={
                  getClassesByTeacherAndDateTimeBetweenDays
                }
                getInfoTeacher={infoDashboardTeacher}
                setInforDashboard={setInfo}
                setLoading={setLoading}
              />
              <Button
                onClick={() => {
                  const currentDate = new Date();
                  const dateObj = {
                    month: (currentDate.getMonth() + 1).toString(),
                    year: currentDate.getFullYear().toString(),
                  };
                  setDate(dateObj);
                }}
              >
                Clear Filters
              </Button>
            </div>
          </div>
          <div className="resumenDeActividadAcademica">
            <div className="actividadCard">
              <h3>Total Hrs Canceled on time</h3>
              <p className="total">
                {info.hoursCanceledParticipantOnTime + info.hoursCanceledTeacherOnTime ||0}
              </p>
            </div>
            <div className="actividadCard">
              <h3>Number of late canceled virtual hours</h3>
              <p className="total">
                {info.hoursCanceledParticipantLateVirtual}
              </p>
            </div>
            <div className="actividadCard">
              <h3>Number of late canceled in-person hours</h3>
              <p className="total">
                {info.hoursCanceledParticipantLateInPerson}
              </p>
            </div>
            <div className="actividadCard">
              <h3>Total planned hours for the month</h3>
              <p className="total">{info.hoursPlanned}</p>
            </div>
            <div className="actividadCard">
              <h3>Total virtual hours</h3>
              <p className="total">{info.hoursHeldVirtual}</p>
            </div>
            <div className="actividadCard">
              <h3>Total in-person hours</h3>
              <p className="total">{info.hoursHeldInPerson}</p>
            </div>
            <div className="actividadCard">
              <h3>Total classes taught</h3>
              <p className="total">{info.hoursHeld}</p>
            </div>
          </div>
          <div className="totales bg-white shadow-md rounded-lg p-6 text-sm">
            {" "}
            <h2 className="text-2xl font-bold mb-4">Totals</h2>
            <div className="invoice space-y-4">
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Total Hours:</span>
                <span>{info.hoursHeld || 0} hours</span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Virtual Hours:</span>
                <span>{info.hoursHeldVirtual || 0} hours</span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">In-person Hours:</span>
                <span>{info.hoursHeldInPerson || 0} hours</span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">
                  Late Cancellations by Student (Virtual):
                </span>
                <span>
                  {info.hoursCanceledParticipantLateVirtual || 0} hours
                </span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">
                  Late Cancellations by Student (In-person):
                </span>
                <span>
                  {info.hoursCanceledParticipantLateInPerson || 0} hours
                </span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">
                  Hours Canceled by Teacher:
                </span>
                <span>{info.hoursCanceledTeacherLate || 0} hours</span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">Virtual Total Value:</span>
                <span>
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                  }).format((info.totalVirtualValue + info.totalVirtualCancelledValue || 0).toFixed(2))}
                </span>
              </div>
              <div className="invoice-item flex justify-between border-b pb-2">
                <span className="font-semibold">In-person Total Value:</span>
                <span>
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                  }).format((info.totalInPersonValue + info.totalInPersonCancelledValue || 0).toFixed(2))}
                </span>
              </div>
              <div 
                className="invoice-item flex justify-between border-b pb-2 cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                onClick={() => setAdditionalPaymentsDialog(true)}
              >
                <span className="font-semibold flex items-center">
                  <PlusSquare className="inline w-4 h-4 mr-2"/>
                  Additional payments:                 
                </span>
                <span>
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                  }).format(
                    (info.totalAdditionalPays || 0).toFixed(2)
                  )}
                </span>
              </div>
              <div className="invoice-item flex justify-between text-xl font-bold mt-4">
                <span>Total Earnings:</span>
                <span>
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                  }).format(
                    (info.totalToPay || 0).toFixed(2)
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="ultimas_clases_estudiante">
            <h2>
              <b>Classes with participants</b>
            </h2>

            {/* Filtros */}
            <div className="filters-section bg-gray-50 p-4 rounded-lg mb-4">
              <h3 className="text-lg font-semibold mb-3">Filters</h3>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Class ID
                  </label>
                  <input
                    type="text"
                    placeholder="Search by ID..."
                    value={filters.idClase}
                    onChange={(e) => handleFilterChange('idClase', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Date (Day)
                  </label>
                  <input
                    type="number"
                    placeholder="Day (1-31)"
                    min="1"
                    max="31"
                    value={filters.fecha}
                    onChange={(e) => handleFilterChange('fecha', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Participant ID
                  </label>
                  <input
                    type="text"
                    placeholder="Participant ID..."
                    value={filters.participanteId}
                    onChange={(e) => handleFilterChange('participanteId', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div className="flex items-end">
                  <Button 
                    variant="outline" 
                    onClick={clearFilters}
                    className="w-full"
                  >
                    Clear Filters
                  </Button>
                </div>
              </div>
            </div>

            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Class ID</TableHead>
                  <TableHead>Date</TableHead>
                  <TableHead>Participant ID</TableHead>
                  <TableHead>Participant</TableHead>
                  <TableHead>Modality</TableHead>
                  <TableHead>Planned H.</TableHead>
                  <TableHead>Duration</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead>Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filteredClasses.map((classData) => (
                  <TableRow key={classData.id}>
                    <TableCell>{classData.id}</TableCell>
                    <TableCell>
                      {new Date(classData.dateTime).toLocaleString("en", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                        timeZoneName: "short", 
                      })}
                    </TableCell>
                    <TableCell>{classData.participantID}</TableCell>
                    <TableCell>{classData.classScope}</TableCell>
                    <TableCell>{classData.classType}</TableCell>
                    <TableCell>{classData.plannedDuration} H</TableCell>
                    <TableCell>{classData.duration} H</TableCell>
                    <TableCell>
                      <div
                        className={`flex items-center justify-center p-1 rounded-lg text-white font-semibold ${
                          classData.classStatus === "Held"
                            ? "bg-green-500"
                            : classData.classStatus === "To be held"
                            ? "bg-gray-500"
                            : classData.duration > 0
                            ? "bg-orange-500"
                            : "bg-red-500"
                        }`}
                      >
                        <span className="w-2 h-2 rounded-full mr-3 bg-white"></span>
                        <span>
                          {classData.classStatus === "To be held"
                            ? "Upcoming"
                            : classData.classStatus === "Held"
                            ? "Completed"
                            : classData.duration > 0
                            ? "Partial"
                            : "Canceled"}
                        </span>
                      </div>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() =>
                          showParticipantInfo(
                            classData.participantID,
                            classData.classScope
                          )
                        }
                      >
                        View info
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            {filteredClasses.length === 0 && classes_participante.length > 0 && (
              <div className="text-center py-8 text-gray-500">
                No classes found matching the applied filters.
              </div>
            )}
          </div>
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default DashBoardProfesor;
